import { render, staticRenderFns } from "./payfor.vue?vue&type=template&id=ef71f654"
import script from "./payfor.vue?vue&type=script&lang=js"
export * from "./payfor.vue?vue&type=script&lang=js"
import style0 from "./payfor.vue?vue&type=style&index=0&id=ef71f654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports